// Not a polyfill, but a wrapper around localStorage to have events when it changes
// See https://stackoverflow.com/a/69380917
Storage.prototype.setItem = new Proxy(Storage.prototype.setItem, {
  apply(target, thisArg, argumentList) {
    const oldValue = thisArg.getItem(argumentList[0]);
    const returnValue = Reflect.apply(target, thisArg, argumentList);

    // React (devtools only ?) stores some data in localStorage and makes us trigger an event
    if (!argumentList[0]?.startsWith('React::')) {
      const event = new CustomEvent('localstorage', {
        detail: {
          key: argumentList[0],
          oldValue,
          newValue: argumentList[1],
        },
      });

      window.dispatchEvent(event);
    }
    return returnValue;
  },
});
